import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";

export const deleteAdminFromAuthAndFirestore = async (
  adminEmail,
  dealershipId,
  operatingUnitId = null,
) => {
  if (!adminEmail) {
    throw new Error("Email de admin no proporcionado");
  }
  if (!dealershipId) {
    throw new Error("ID de concesionaria no proporcionado");
  }

  const deleteAdminFn = httpsCallable(
    functions,
    "deleteAdminFromAuthAndFirestoreV2",
  );
  const result = await deleteAdminFn({
    email: adminEmail,
    dealershipId,
    requestedApp: "group_web",
    ...(operatingUnitId ? { operatingUnitId } : {}),
  });
  if (!result.data || result.data.success !== "yes") {
    throw new Error(
      result.data?.message || "Error desconocido al eliminar admin",
    );
  }
  return result.data;
};
